import { useState, useEffect, useRef, useCallback } from "react";

/* ─────────────────────────────── STYLES ─────────────────────────────── */
const Styles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800;900&family=DM+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&display=swap');
    *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
    html{scroll-behavior:smooth}
    body{font-family:'DM Sans',sans-serif;background:#F7F4EE;color:#0f172a;overflow-x:hidden}
    :root{
      --cream:#F7F4EE;--white:#fff;--navy:#0D1B4B;--navy2:#162050;
      --gold:#F5A623;--gold2:#FFD166;--teal:#00C2A8;--teal2:#009E88;
      --muted:#64748b;--border:#E4DDD0;
      --fh:'Syne',sans-serif;--fb:'DM Sans',sans-serif;
      --sh:0 4px 24px rgba(13,27,75,.08);--shl:0 16px 48px rgba(13,27,75,.14);
    }
    ::-webkit-scrollbar{width:4px}
    ::-webkit-scrollbar-thumb{background:var(--gold);border-radius:99px}

    @keyframes fadeUp{from{opacity:0;transform:translateY(36px)}to{opacity:1;transform:none}}
    @keyframes scaleIn{from{opacity:0;transform:scale(.88)}to{opacity:1;transform:scale(1)}}
    @keyframes marqueeX{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}
    @keyframes marqueeXR{0%{transform:translateX(-50%)}100%{transform:translateX(0)}}
    @keyframes scrollUpY{0%{transform:translateY(0)}100%{transform:translateY(-50%)}}
    @keyframes gradFlow{0%{background-position:0% 50%}50%{background-position:100% 50%}100%{background-position:0% 50%}}
    @keyframes heroSlide{from{opacity:0;transform:translateY(22px)}to{opacity:1;transform:none}}
    @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}
    @keyframes ripple{0%{transform:scale(0);opacity:.5}100%{transform:scale(5);opacity:0}}
    @keyframes spin360{to{transform:rotate(360deg)}}
    @keyframes pulse{0%,100%{box-shadow:0 0 0 0 rgba(245,166,35,.4)}50%{box-shadow:0 0 0 12px rgba(245,166,35,0)}}

    .au{animation:fadeUp .7s cubic-bezier(.22,1,.36,1) both}
    .as{animation:scaleIn .6s cubic-bezier(.22,1,.36,1) both}
    .d1{animation-delay:.08s}.d2{animation-delay:.18s}.d3{animation-delay:.3s}
    .d4{animation-delay:.42s}.d5{animation-delay:.55s}.d6{animation-delay:.7s}

    /* ═══════ HERO IMAGE SLIDER ═══════ */
    .hero-wrap{position:relative;width:100%;height:100vh;min-height:640px;overflow:hidden;background:#000}
    .hslide{position:absolute;inset:0;opacity:0;transition:opacity 1.1s ease;z-index:0}
    .hslide.active{opacity:1;z-index:1}
    .hslide-img{
      position:absolute;inset:0;background-size:cover;background-position:center;
      transform:scale(1.08);transition:transform 6s ease;
    }
    .hslide.active .hslide-img{transform:scale(1)}
    .hslide-overlay{
      position:absolute;inset:0;
      background:linear-gradient(to right,rgba(13,27,75,.88) 0%,rgba(13,27,75,.6) 55%,rgba(13,27,75,.15) 100%);
    }
    .hslide-overlay2{
      position:absolute;inset:0;
      background:linear-gradient(to top,rgba(13,27,75,.7) 0%,transparent 40%);
    }
    .hslide-content{
      position:relative;z-index:3;height:100%;
      display:flex;align-items:center;
      max-width:1280px;margin:0 auto;padding:0 3.5rem;
    }
    .hslide-text{max-width:660px}
    .hslide-chip{
      display:inline-flex;align-items:center;gap:.5rem;margin-bottom:1.5rem;
      background:rgba(0,194,168,.18);border:1px solid rgba(0,194,168,.45);
      color:#5dffd9;padding:.38rem 1rem;border-radius:100px;
      font-size:.72rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;
      animation:heroSlide .7s .1s ease both;
    }
    .hslide-h1{
      font-family:var(--fh);font-size:clamp(2.6rem,5.5vw,4.5rem);
      color:#fff;line-height:1.04;margin-bottom:1.1rem;
      animation:heroSlide .75s .25s ease both;
    }
    .hslide-h1 em{
      font-style:normal;color:transparent;
      background:linear-gradient(90deg,#F5A623,#FFD166,#ff9f3f,#F5A623);
      background-size:300% auto;-webkit-background-clip:text;background-clip:text;
      animation:gradFlow 3s linear infinite;
    }
    .hslide-p{
      font-size:1.02rem;color:rgba(255,255,255,.62);line-height:1.78;margin-bottom:2rem;
      animation:heroSlide .75s .4s ease both;
    }
    .hslide-btns{display:flex;gap:.9rem;flex-wrap:wrap;animation:heroSlide .75s .55s ease both}
    .btn-hp{
      background:linear-gradient(135deg,var(--gold),var(--gold2));
      color:var(--navy);border:none;padding:.92rem 2.2rem;border-radius:11px;
      font-weight:800;font-size:.95rem;cursor:pointer;position:relative;overflow:hidden;
      box-shadow:0 4px 22px rgba(245,166,35,.45);transition:transform .2s,box-shadow .2s;
    }
    .btn-hp::after{content:'';position:absolute;inset:0;background:rgba(255,255,255,.22);transform:translateX(-110%);transition:transform .35s}
    .btn-hp:hover::after{transform:translateX(0)}
    .btn-hp:hover{transform:translateY(-2px);box-shadow:0 10px 34px rgba(245,166,35,.6)}
    .btn-hg{
      background:rgba(255,255,255,.08);color:#fff;
      border:1.5px solid rgba(255,255,255,.3);padding:.92rem 1.6rem;
      border-radius:11px;font-weight:600;font-size:.9rem;cursor:pointer;
      backdrop-filter:blur(8px);transition:all .2s;display:flex;align-items:center;gap:.4rem;
    }
    .btn-hg:hover{background:rgba(255,255,255,.18);border-color:rgba(255,255,255,.6)}

    /* Hero stats bar */
    .hero-stats-bar{
      position:absolute;bottom:0;left:0;right:0;z-index:5;
      background:rgba(13,27,75,.82);backdrop-filter:blur(20px);
      border-top:1px solid rgba(255,255,255,.08);
      display:flex;align-items:center;padding:0 3.5rem;height:76px;
    }
    .hstat{flex:1;display:flex;align-items:center;gap:.8rem;padding:0 1.5rem;border-right:1px solid rgba(255,255,255,.1)}
    .hstat:first-child{padding-left:0}
    .hstat:last-child{border-right:none}
    .hstat-ico{font-size:1.5rem;flex-shrink:0}
    .hstat-val{font-family:var(--fh);font-size:1.55rem;font-weight:900;color:var(--gold);line-height:1}
    .hstat-lbl{font-size:.74rem;color:rgba(255,255,255,.45);font-weight:500;margin-top:2px}

    /* Hero controls */
    .hero-ctrl{
      position:absolute;right:3.5rem;top:50%;transform:translateY(-50%);
      z-index:10;display:flex;flex-direction:column;gap:.6rem;
    }
    .hcdot{
      width:4px;height:28px;border-radius:99px;background:rgba(255,255,255,.25);
      cursor:pointer;transition:all .3s;border:none;
    }
    .hcdot.on{background:var(--gold);height:44px}
    .hero-arrows{
      position:absolute;bottom:5.5rem;right:3.5rem;z-index:10;
      display:flex;gap:.5rem;
    }
    .harr{
      width:44px;height:44px;border-radius:50%;
      background:rgba(255,255,255,.1);border:1.5px solid rgba(255,255,255,.25);
      color:#fff;cursor:pointer;font-size:1rem;backdrop-filter:blur(8px);
      display:flex;align-items:center;justify-content:center;transition:all .2s;
    }
    .harr:hover{background:var(--gold);color:var(--navy);border-color:var(--gold)}
    .hero-progress{position:absolute;bottom:76px;left:0;right:0;height:3px;background:rgba(255,255,255,.1);z-index:6}
    .hero-pbar{height:100%;background:linear-gradient(90deg,var(--teal),var(--gold));transition:width 5.5s linear}

    /* ═══════ MARQUEE ═══════ */
    .mwrap{background:var(--navy2);overflow:hidden;padding:.9rem 0;border-bottom:1px solid rgba(255,255,255,.05)}
    .mtrack{display:flex;width:max-content;animation:marqueeX 32s linear infinite}
    .mtrack:hover{animation-play-state:paused}
    .mexam{display:flex;align-items:center;gap:.6rem;padding:.38rem 2rem;white-space:nowrap;font-size:.84rem;font-weight:600;color:rgba(255,255,255,.7);border-right:1px solid rgba(255,255,255,.08)}
    .mdot{width:7px;height:7px;border-radius:50%;background:var(--teal);flex-shrink:0}
    .mdot.g{background:var(--gold)}

    /* ═══════ SECTION COMMONS ═══════ */
    section{padding:5.5rem 2.5rem}
    .cnt{max-width:1200px;margin:0 auto}
    .stag{display:inline-flex;align-items:center;gap:.5rem;font-size:.72rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:var(--teal);margin-bottom:.7rem}
    .stag::before{content:'';width:20px;height:2px;background:var(--teal)}
    .sh{font-family:var(--fh);font-size:clamp(1.8rem,3.5vw,2.8rem);color:var(--navy);margin-bottom:.7rem;line-height:1.15}
    .sh em{color:var(--gold);font-style:normal}
    .sd{color:var(--muted);font-size:.93rem;line-height:1.78;max-width:600px}
    .shr{display:flex;align-items:flex-end;justify-content:space-between;margin-bottom:3rem;gap:2rem}
    .btn-nv{background:var(--navy);color:#fff;border:none;padding:.88rem 2rem;border-radius:10px;font-weight:700;font-size:.9rem;cursor:pointer;transition:all .2s;box-shadow:0 4px 18px rgba(13,27,75,.22)}
    .btn-nv:hover{background:var(--navy2);transform:translateY(-2px)}
    .btn-gd{background:linear-gradient(135deg,var(--gold),var(--gold2));color:var(--navy);border:none;padding:.88rem 2rem;border-radius:10px;font-weight:800;font-size:.9rem;cursor:pointer;transition:all .2s;box-shadow:0 4px 20px rgba(245,166,35,.4)}
    .btn-gd:hover{transform:translateY(-2px);box-shadow:0 10px 32px rgba(245,166,35,.55)}

    /* ═══════ COURSES ═══════ */
    .courses-sec{background:var(--white)}
    .ctab-row{display:flex;gap:.6rem;margin-bottom:2.5rem;flex-wrap:wrap}
    .ctab{padding:.6rem 1.3rem;border-radius:100px;font-weight:600;font-size:.84rem;cursor:pointer;border:1.5px solid var(--border);background:var(--white);color:var(--muted);transition:all .25s}
    .ctab.on{background:var(--navy);color:#fff;border-color:var(--navy);box-shadow:0 4px 16px rgba(13,27,75,.2)}
    .cgrid{display:grid;grid-template-columns:repeat(3,1fr);gap:1.5rem}
    .ccard{background:var(--cream);border-radius:20px;overflow:hidden;border:1px solid var(--border);transition:transform .25s,box-shadow .25s;cursor:pointer;position:relative}
    .ccard:hover{transform:translateY(-6px);box-shadow:var(--shl)}
    .ccard-img{height:158px;background:linear-gradient(135deg,#0D1B4B,#162050);display:flex;align-items:center;justify-content:center;font-size:3.5rem;position:relative;overflow:hidden}
    .ccard-img::after{content:'';position:absolute;inset:0;background:linear-gradient(to bottom,transparent 50%,rgba(13,27,75,.55))}
    .ccard-badge{position:absolute;top:.8rem;left:.8rem;z-index:2;background:linear-gradient(135deg,var(--gold),var(--gold2));color:var(--navy);padding:.2rem .6rem;border-radius:5px;font-size:.65rem;font-weight:800;letter-spacing:.06em;text-transform:uppercase}
    .ccard-body{padding:1.4rem}
    .ccard-lbl{font-size:.68rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:var(--teal);margin-bottom:.35rem}
    .ccard-name{font-family:var(--fh);font-size:1.05rem;color:var(--navy);margin-bottom:.38rem;line-height:1.3;font-weight:700}
    .ccard-desc{font-size:.8rem;color:var(--muted);line-height:1.6;margin-bottom:.9rem}
    .ccard-tags{display:flex;gap:.5rem;flex-wrap:wrap;margin-bottom:.9rem}
    .ctag-pill{background:rgba(13,27,75,.07);color:var(--navy);font-size:.7rem;font-weight:600;padding:.2rem .55rem;border-radius:5px}
    .ccard-foot{display:flex;align-items:center;justify-content:space-between;padding-top:.8rem;border-top:1px solid var(--border)}
    .ccard-price{font-family:var(--fh);font-size:1.1rem;font-weight:900;color:var(--navy)}
    .ccard-price span{font-size:.7rem;color:var(--muted);font-weight:400;font-family:var(--fb)}
    .ccard-btn{background:var(--navy);color:#fff;border:none;padding:.4rem 1rem;border-radius:7px;font-size:.78rem;font-weight:700;cursor:pointer;transition:all .2s}
    .ccard-btn:hover{background:var(--gold);color:var(--navy)}

    /* ═══════ EXAM CATEGORIES ═══════ */
    .exams-sec{background:var(--cream)}
    .etabs{display:flex;gap:.7rem;margin-bottom:2.5rem;flex-wrap:wrap}
    .etab{padding:.6rem 1.3rem;border-radius:100px;font-weight:600;font-size:.84rem;cursor:pointer;border:1.5px solid var(--border);background:var(--white);color:var(--muted);transition:all .25s}
    .etab.on{background:var(--navy);color:#fff;border-color:var(--navy);box-shadow:0 4px 16px rgba(13,27,75,.2)}
    .egrid{display:grid;grid-template-columns:repeat(auto-fill,minmax(255px,1fr));gap:1.2rem}
    .ecard{background:var(--white);border-radius:18px;padding:1.8rem;border:1px solid var(--border);transition:transform .25s,box-shadow .25s,border-color .25s;cursor:pointer;position:relative;overflow:hidden}
    .ecard::after{content:'';position:absolute;bottom:0;left:0;right:0;height:3px;background:linear-gradient(90deg,var(--teal),var(--gold));transform:scaleX(0);transform-origin:left;transition:transform .3s}
    .ecard:hover{transform:translateY(-5px);box-shadow:var(--shl);border-color:transparent}
    .ecard:hover::after{transform:scaleX(1)}
    .eclbl{font-size:.68rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:var(--teal);margin-bottom:.4rem}
    .ect{font-family:var(--fh);font-size:1.5rem;color:var(--navy);margin-bottom:.5rem}
    .ecd{font-size:.83rem;color:var(--muted);line-height:1.65;margin-bottom:.9rem}
    .ecl{display:inline-flex;align-items:center;gap:.3rem;color:var(--gold);font-weight:700;font-size:.83rem}

    /* ═══════ PREP STEPS — REDESIGNED ═══════ */
    .prep-sec{
      background:var(--navy);
      padding:6rem 2.5rem;position:relative;overflow:hidden;
    }
    .prep-bg-grid{
      position:absolute;inset:0;
      background-image:linear-gradient(rgba(255,255,255,.03) 1px,transparent 1px),
        linear-gradient(90deg,rgba(255,255,255,.03) 1px,transparent 1px);
      background-size:60px 60px;pointer-events:none;
    }
    .prep-orb{position:absolute;border-radius:50%;filter:blur(80px);pointer-events:none}
    .po1{width:500px;height:500px;background:radial-gradient(var(--teal),transparent 70%);top:-150px;right:-100px;opacity:.18}
    .po2{width:400px;height:400px;background:radial-gradient(var(--gold),transparent 70%);bottom:-120px;left:-80px;opacity:.14}
    .prep-sec .stag{color:var(--teal)}
    .prep-sec .sh{color:#fff}
    .prep-sec .sd{color:rgba(255,255,255,.5)}
    .prep-steps-grid{
      display:grid;grid-template-columns:repeat(5,1fr);gap:1.5rem;
      margin-top:4rem;position:relative;z-index:1;
    }
    .prep-steps-grid::before{
      content:'';position:absolute;top:42px;left:calc(10% + 24px);right:calc(10% + 24px);
      height:2px;
      background:linear-gradient(90deg,var(--teal) 0%,var(--gold) 50%,var(--teal) 100%);
      z-index:0;opacity:.5;
    }
    .pstep{
      display:flex;flex-direction:column;align-items:center;text-align:center;
      position:relative;z-index:1;
    }
    .pstep-num-wrap{position:relative;margin-bottom:1.5rem}
    .pstep-ring{
      width:84px;height:84px;border-radius:50%;
      border:2px solid rgba(0,194,168,.3);
      display:flex;align-items:center;justify-content:center;
      position:relative;transition:border-color .3s;
    }
    .pstep:hover .pstep-ring{border-color:var(--teal)}
    .pstep-ring::before{
      content:'';position:absolute;inset:-6px;border-radius:50%;
      border:1px solid rgba(245,166,35,.15);
    }
    .pstep-inner{
      width:64px;height:64px;border-radius:50%;
      background:linear-gradient(135deg,var(--teal),var(--teal2));
      display:flex;align-items:center;justify-content:center;
      font-family:var(--fh);font-size:1.3rem;font-weight:900;color:#fff;
      box-shadow:0 8px 24px rgba(0,194,168,.35);
      transition:transform .3s,box-shadow .3s;
    }
    .pstep:hover .pstep-inner{transform:scale(1.1);box-shadow:0 12px 32px rgba(0,194,168,.5)}
    .pstep-icon{
      position:absolute;top:-4px;right:-4px;
      width:28px;height:28px;border-radius:50%;
      background:linear-gradient(135deg,var(--gold),var(--gold2));
      display:flex;align-items:center;justify-content:center;
      font-size:.9rem;box-shadow:0 4px 10px rgba(245,166,35,.4);
    }
    .pstep-card{
      background:rgba(255,255,255,.05);
      border:1px solid rgba(255,255,255,.08);
      border-radius:16px;padding:1.2rem 1rem;
      transition:background .3s,border-color .3s,transform .3s;
      width:100%;
    }
    .pstep:hover .pstep-card{
      background:rgba(255,255,255,.09);
      border-color:rgba(0,194,168,.35);
      transform:translateY(-4px);
    }
    .pstep-title{font-weight:700;font-size:.9rem;color:#fff;margin-bottom:.45rem;line-height:1.3}
    .pstep-desc{font-size:.76rem;color:rgba(255,255,255,.48);line-height:1.65}

    /* ═══════ YOUTUBE VIDEO LOOP ═══════ */
    .ytloop-sec{background:var(--navy2);padding:5.5rem 2.5rem;overflow:hidden}
    .ytloop-sec .stag{color:var(--teal)}
    .ytloop-sec .sh{color:#fff}
    .ytloop-sec .sd{color:rgba(255,255,255,.5)}
    .yt-rows{display:flex;flex-direction:column;gap:1.2rem;margin-top:3rem;
      -webkit-mask:linear-gradient(90deg,transparent,#fff 8%,#fff 92%,transparent);
      mask:linear-gradient(90deg,transparent,#fff 8%,#fff 92%,transparent);
    }
    .yt-row{display:flex;gap:1.2rem;overflow:hidden}
    .yt-track{display:flex;gap:1.2rem;animation:marqueeX 28s linear infinite;flex-shrink:0}
    .yt-track.rev{animation:marqueeXR 28s linear infinite}
    .yt-track:hover{animation-play-state:paused}
    .ytcard{
      flex-shrink:0;width:280px;border-radius:16px;overflow:hidden;
      background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.08);
      cursor:pointer;transition:transform .3s,box-shadow .3s;
    }
    .ytcard:hover{transform:scale(1.03);box-shadow:0 20px 50px rgba(0,0,0,.4)}
    .ytcard-thumb{
      position:relative;width:100%;padding-top:56.25%;overflow:hidden;
      background:linear-gradient(135deg,#0D1B4B,#162050);
    }
    .ytcard-thumb iframe{
      position:absolute;inset:0;width:100%;height:100%;
      border:none;pointer-events:none;
    }
    .ytcard-thumb .yt-poster{
      position:absolute;inset:0;background:linear-gradient(135deg,#1e3a5f,#0D1B4B);
      display:flex;align-items:center;justify-content:center;
      flex-direction:column;gap:.5rem;transition:opacity .3s;
    }
    .ytcard:hover .yt-poster{opacity:0}
    .ytcard-play{
      width:52px;height:52px;border-radius:50%;
      background:#ff0000;display:flex;align-items:center;justify-content:center;
      font-size:1.2rem;box-shadow:0 4px 18px rgba(255,0,0,.45);
      animation:pulse 2s ease infinite;
    }
    .ytcard-info{padding:1rem}
    .ytcard-name{font-weight:700;color:#fff;font-size:.85rem;margin-bottom:.2rem}
    .ytcard-exam{font-size:.75rem;color:var(--teal);font-weight:600}
    .ytcard-stars{color:var(--gold);font-size:.7rem;letter-spacing:2px;margin-top:.2rem}

    /* YT Modal */
    .yt-modal{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.9);backdrop-filter:blur(14px);padding:1.5rem}
    .yt-modal-box{width:100%;max-width:860px;border-radius:20px;overflow:hidden;position:relative;box-shadow:0 30px 80px rgba(0,0,0,.6)}
    .yt-modal-box .yt-close{position:absolute;top:.75rem;right:.75rem;z-index:2;background:rgba(255,255,255,.15);border:none;color:#fff;width:38px;height:38px;border-radius:50%;cursor:pointer;font-size:1.1rem;display:flex;align-items:center;justify-content:center;transition:background .2s}
    .yt-modal-box .yt-close:hover{background:rgba(255,0,0,.7)}
    .yt-iframe-wrap{position:relative;width:100%;padding-top:56.25%}
    .yt-iframe-wrap iframe{position:absolute;inset:0;width:100%;height:100%;border:none}

    /* ═══════ 3-COL TESTIMONIAL LOOP ═══════ */
    .tloop-sec{background:var(--cream);padding:5.5rem 2.5rem;overflow:hidden}
    .tloop-cols{
      display:grid;grid-template-columns:repeat(3,1fr);gap:1.2rem;margin-top:3rem;
      height:680px;overflow:hidden;position:relative;
      -webkit-mask:linear-gradient(to bottom,transparent,#fff 8%,#fff 92%,transparent);
      mask:linear-gradient(to bottom,transparent,#fff 8%,#fff 92%,transparent);
    }
    .tloop-col{display:flex;flex-direction:column;gap:1.2rem}
    .tcol-track{display:flex;flex-direction:column;gap:1.2rem;animation:scrollUpY var(--dur,28s) linear infinite}
    .tcol-track:hover{animation-play-state:paused}
    .tloopcard{
      background:var(--white);border-radius:20px;padding:1.8rem;
      border:1px solid var(--border);position:relative;overflow:hidden;
      flex-shrink:0;transition:transform .25s,box-shadow .25s;cursor:default;
    }
    .tloopcard:hover{transform:translateY(-3px);box-shadow:var(--shl)}
    .tloopcard-accent{position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,var(--teal),var(--gold))}
    .tloopcard-q{font-family:var(--fh);font-size:4.5rem;color:rgba(245,166,35,.09);line-height:1;position:absolute;top:.8rem;right:1.2rem}
    .tlc-stars{color:var(--gold);font-size:.8rem;letter-spacing:3px;margin-bottom:.85rem}
    .tlc-text{font-size:.85rem;color:#44475a;line-height:1.78;font-style:italic;margin-bottom:1.2rem}
    .tlc-person{display:flex;align-items:center;gap:.75rem}
    .tlc-avatar{
      width:42px;height:42px;border-radius:50%;flex-shrink:0;
      display:flex;align-items:center;justify-content:center;
      font-family:var(--fh);font-weight:700;font-size:.95rem;color:#fff;
    }
    .tlc-name{font-weight:700;color:var(--navy);font-size:.88rem}
    .tlc-role{font-size:.74rem;color:var(--teal);font-weight:600;margin-top:1px}
    .tlc-badge{display:inline-flex;align-items:center;gap:.3rem;background:rgba(0,194,168,.1);border:1px solid rgba(0,194,168,.25);color:var(--teal2);font-size:.65rem;font-weight:700;padding:.15rem .5rem;border-radius:4px;margin-top:.28rem}

    /* ═══════ ENQUIRY FORM ═══════ */
    .enq-sec{background:linear-gradient(135deg,#0D1B4B,#162050,#0B2E48);position:relative;overflow:hidden}
    .enq-orb{position:absolute;border-radius:50%;filter:blur(90px);pointer-events:none}
    .eo1{width:500px;height:500px;background:radial-gradient(var(--teal),transparent 70%);top:-150px;right:-80px;opacity:.18}
    .eo2{width:400px;height:400px;background:radial-gradient(var(--gold),transparent 70%);bottom:-100px;left:-80px;opacity:.14}
    .enq-grid{display:grid;grid-template-columns:1fr 1fr;position:relative;z-index:1;min-height:600px}
    .enq-left{padding:5.5rem 3.5rem;display:flex;flex-direction:column;justify-content:center}
    .enq-left .stag{color:var(--teal)}
    .enq-left .sh{color:#fff}
    .enq-left .sd{color:rgba(255,255,255,.5);margin-bottom:2rem}
    .enq-pts{display:flex;flex-direction:column;gap:1rem}
    .enq-pt{display:flex;align-items:flex-start;gap:.85rem}
    .enq-ico{width:42px;height:42px;border-radius:12px;background:rgba(0,194,168,.14);border:1px solid rgba(0,194,168,.28);display:flex;align-items:center;justify-content:center;font-size:1.1rem;flex-shrink:0}
    .enq-pt h4{font-weight:700;color:#fff;font-size:.9rem;margin-bottom:.15rem}
    .enq-pt p{font-size:.8rem;color:rgba(255,255,255,.42);line-height:1.6}
    .enq-right{background:var(--white);padding:4.5rem 3.5rem;display:flex;flex-direction:column;justify-content:center}
    .ftitle{font-family:var(--fh);font-size:1.6rem;color:var(--navy);margin-bottom:.35rem}
    .fsub{font-size:.88rem;color:var(--muted);margin-bottom:1.8rem}
    .frow{display:grid;grid-template-columns:1fr 1fr;gap:1rem}
    .fg{display:flex;flex-direction:column;gap:.38rem;margin-bottom:.9rem}
    .fg label{font-size:.76rem;font-weight:700;color:var(--navy);letter-spacing:.02em}
    .fg input,.fg select,.fg textarea{
      background:var(--cream);border:1.5px solid var(--border);border-radius:10px;
      padding:.72rem 1rem;font-size:.87rem;color:var(--navy);font-family:var(--fb);
      transition:border-color .2s,box-shadow .2s;outline:none;width:100%;
    }
    .fg input:focus,.fg select:focus,.fg textarea:focus{border-color:var(--teal);box-shadow:0 0 0 3px rgba(0,194,168,.12)}
    .fg textarea{resize:vertical;min-height:86px}
    .fsub-btn{
      width:100%;padding:1rem;
      background:linear-gradient(135deg,var(--navy),var(--navy2));
      color:#fff;border:none;border-radius:12px;font-weight:800;font-size:1rem;
      cursor:pointer;transition:all .25s;box-shadow:0 4px 18px rgba(13,27,75,.25);
      position:relative;overflow:hidden;margin-top:.35rem;
    }
    .fsub-btn::after{content:'';position:absolute;inset:0;background:linear-gradient(135deg,var(--gold),var(--gold2));opacity:0;transition:opacity .3s}
    .fsub-btn:hover::after{opacity:1}
    .fsub-btn:hover{transform:translateY(-2px)}
    .fsub-btn span{position:relative;z-index:1}
    .fnote{font-size:.73rem;color:var(--muted);text-align:center;margin-top:.7rem}
    .fsuccess{text-align:center;padding:3rem 2rem}
    .fsuccess .tick{font-size:3.8rem;display:block;margin-bottom:.8rem;animation:scaleIn .5s ease}
    .fsuccess h3{font-family:var(--fh);font-size:1.5rem;color:var(--navy);margin-bottom:.45rem}
    .fsuccess p{color:var(--muted);font-size:.9rem}

    /* ═══════ NOTIFICATIONS ═══════ */
    .notif-sec{background:linear-gradient(135deg,#0D1B4B,#162050);padding:5.5rem 2.5rem}
    .notif-grid{display:grid;grid-template-columns:1fr 2fr;gap:4rem;align-items:flex-start}
    .notif-sec .stag{color:var(--teal)}
    .notif-sec .sh{color:#fff}
    .notif-sec .sd{color:rgba(255,255,255,.45);margin-top:.5rem}
    .nscroll{height:380px;overflow:hidden;border-radius:18px;border:1px solid rgba(255,255,255,.07);position:relative}
    .nscroll::before,.nscroll::after{content:'';position:absolute;left:0;right:0;height:60px;z-index:2;pointer-events:none}
    .nscroll::before{top:0;background:linear-gradient(to bottom,rgba(13,27,75,1),transparent)}
    .nscroll::after{bottom:0;background:linear-gradient(to top,rgba(22,32,80,1),transparent)}
    .ntrack{display:flex;flex-direction:column;animation:scrollUpY 22s linear infinite}
    .ntrack:hover{animation-play-state:paused}
    .nrow{display:flex;align-items:center;gap:1rem;padding:1rem 1.4rem;border-bottom:1px solid rgba(255,255,255,.04);transition:background .2s;cursor:pointer}
    .nrow:hover{background:rgba(255,255,255,.04)}
    .ndot{width:10px;height:10px;border-radius:50%;flex-shrink:0}
    .nd-new{background:var(--gold)}.nd-exam{background:var(--teal)}.nd-hall{background:#a78bfa}.nd-rec{background:#34d399}
    .nc{flex:1}
    .nc h4{font-size:.88rem;font-weight:600;color:rgba(255,255,255,.88);margin-bottom:.18rem;line-height:1.4}
    .nc span{font-size:.74rem;color:rgba(255,255,255,.32)}
    .nbadge{font-size:.62rem;font-weight:800;letter-spacing:.07em;text-transform:uppercase;padding:.22rem .6rem;border-radius:5px;white-space:nowrap;flex-shrink:0}
    .nb-new{background:rgba(245,166,35,.18);color:var(--gold)}.nb-exam{background:rgba(0,194,168,.18);color:var(--teal)}.nb-hall{background:rgba(167,139,250,.18);color:#a78bfa}.nb-rec{background:rgba(52,211,153,.18);color:#34d399}

    /* ═══════ STANDARDS ═══════ */
    .std-sec{background:var(--white)}
    .std-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:1.25rem;margin-top:3rem}
    .stdc{background:var(--cream);border-radius:20px;padding:2rem;border:1px solid var(--border);transition:transform .25s,box-shadow .25s}
    .stdc:hover{transform:translateY(-5px);box-shadow:var(--shl)}
    .stdic{width:54px;height:54px;border-radius:14px;background:linear-gradient(135deg,rgba(0,194,168,.12),rgba(0,194,168,.04));display:flex;align-items:center;justify-content:center;font-size:1.6rem;margin-bottom:1rem}
    .stdc h3{font-weight:700;color:var(--navy);margin-bottom:.45rem;font-size:1rem}
    .stdc p{font-size:.83rem;color:var(--muted);line-height:1.72}

    /* ═══════ CTA BANNER ═══════ */
    .cta-banner{background:linear-gradient(135deg,var(--gold),#ffb347,var(--gold2));padding:4.5rem 2.5rem;text-align:center;position:relative;overflow:hidden}
    .cta-banner::before{content:'';position:absolute;inset:0;background:radial-gradient(circle at 20% 50%,rgba(255,255,255,.15),transparent 60%)}
    .cta-banner>*{position:relative;z-index:1}

    /* ═══════ FOOTER ═══════ */
    .footer{background:var(--navy);color:rgba(255,255,255,.45);padding:4rem 2.5rem 7rem}
    .fin{max-width:1200px;margin:0 auto}
    .fgrid{display:grid;grid-template-columns:2fr 1fr 1fr 1fr;gap:3rem;margin-bottom:3rem}
    .flogo{font-family:var(--fh);font-size:1.5rem;color:#fff;margin-bottom:.75rem;font-weight:900}
    .flogo em{color:var(--gold);font-style:normal}
    .fdesc{font-size:.83rem;line-height:1.78;max-width:280px}
    .fh4{color:#fff;font-size:.8rem;font-weight:700;text-transform:uppercase;letter-spacing:.1em;margin-bottom:1.2rem}
    .footer a{display:block;color:rgba(255,255,255,.45);text-decoration:none;font-size:.83rem;margin-bottom:.5rem;transition:color .2s}
    .footer a:hover{color:var(--gold)}
    .fbot{padding-top:1.5rem;border-top:1px solid rgba(255,255,255,.07);font-size:.78rem;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:1rem}

    /* ═══════ BOTTOM NAV ═══════ */
    .bnav{position:fixed;bottom:0;left:0;right:0;z-index:1000;background:rgba(13,27,75,.97);backdrop-filter:blur(20px);border-top:1px solid rgba(245,166,35,.2);display:flex;align-items:center;justify-content:space-between;padding:0 2.5rem;height:62px}
    .bnav-logo{font-family:var(--fh);font-size:1.1rem;color:#fff}
    .bnav-logo em{color:var(--gold);font-style:normal}
    .bnav-links{display:flex;list-style:none}
    .bnav-links li a{color:rgba(255,255,255,.65);text-decoration:none;font-size:.82rem;font-weight:500;padding:0 1rem;height:62px;display:flex;align-items:center;border-bottom:3px solid transparent;transition:all .2s}
    .bnav-links li a:hover{color:var(--gold);border-bottom-color:var(--gold)}
    .bnav-cta{background:linear-gradient(135deg,var(--gold),var(--gold2));color:var(--navy);border:none;padding:.52rem 1.5rem;border-radius:8px;font-weight:800;font-size:.85rem;cursor:pointer;transition:transform .2s,box-shadow .2s;box-shadow:0 4px 16px rgba(245,166,35,.4)}
    .bnav-cta:hover{transform:translateY(-2px);box-shadow:0 8px 28px rgba(245,166,35,.6)}

    /* ═══════ RESPONSIVE ═══════ */
    @media(max-width:1100px){
      .cgrid{grid-template-columns:repeat(2,1fr)}
      .prep-steps-grid{grid-template-columns:repeat(3,1fr)}
      .prep-steps-grid::before{display:none}
      .std-grid{grid-template-columns:repeat(2,1fr)}
      .enq-grid{grid-template-columns:1fr}
      .tloop-cols{grid-template-columns:repeat(2,1fr);height:600px}
      .fgrid{grid-template-columns:1fr 1fr;gap:2rem}
    }
    @media(max-width:768px){
      .cgrid{grid-template-columns:1fr}
      .prep-steps-grid{grid-template-columns:repeat(2,1fr)}
      .tloop-cols{grid-template-columns:1fr;height:500px}
      .notif-grid{grid-template-columns:1fr}
      .bnav-links{display:none}
      .hero-stats-bar{flex-wrap:wrap;height:auto;padding:1rem 1.5rem;gap:.3rem}
      .hstat{border-right:none;padding:.25rem .8rem}
      .hero-ctrl{display:none}
    }
  `}</style>
);

/* ─────────────────────────────── DATA ─────────────────────────────── */

// Hero slides use real Unsplash education images
const HERO_SLIDES = [
  {
    img:"https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=1800&q=80",
    chip:"🏛 Official TRB Exam Preparation Portal",
    h1:<>Your Gateway to <em>Government Teaching</em> Careers</>,
    p:"Comprehensive guidance for TNTET, PG TRB, UG TRB & College TRB exams. Join 50,000+ aspirants on the path to a dream government teaching career in Tamil Nadu.",
  },
  {
    img:"https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=1800&q=80",
    chip:"🎓 PG TRB 2025 — Applications Open Now",
    h1:<>PG TRB 2025 — <em>Apply Now</em> Before the Deadline</>,
    p:"Post-Graduate level TRB recruitment exam for higher secondary government school teaching roles. Expert faculty, full syllabus coverage & mock test series.",
  },
  {
    img:"https://images.unsplash.com/photo-1509062522246-3755977927d7?w=1800&q=80",
    chip:"📚 TNTET 2025 — Start Preparing Today",
    h1:<>TNTET 2025 — <em>Clear on Your</em> First Attempt</>,
    p:"Tamil Nadu Teacher Eligibility Test for Classes I–VIII & IX–XII. The mandatory gateway for all aspiring government school teachers. Expert-guided preparation.",
  },
  {
    img:"https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=1800&q=80",
    chip:"🏫 College TRB & TNSET 2025",
    h1:<>College TRB & TNSET — <em>Become an</em> Assistant Professor</>,
    p:"Recruitment for lecturers and assistant professors in government arts, science & polytechnic colleges across Tamil Nadu. Structured, up-to-date preparation.",
  },
];

const COURSES = [
  {icon:"📚",badge:"POPULAR",label:"TNTET PREP",name:"TNTET 2025 Complete Course",desc:"Paper I & II — Child Dev, Language, Math, EVS, Science, Social. Full mock series included.",tags:["Paper I & II","Mock Tests","PDF Notes"],price:"₹2,499",period:"/month"},
  {icon:"🎓",badge:"NEW",label:"PG TRB PREP",name:"PG TRB Mathematics 2025",desc:"Comprehensive coverage of all PG TRB topics for Math teachers — post-graduate level exam prep.",tags:["Subject Focus","Previous Papers","Live Classes"],price:"₹3,299",period:"/month"},
  {icon:"🏫",badge:"BESTSELLER",label:"UG TRB PREP",name:"UG TRB Complete Batch",desc:"Under-graduate level TRB recruitment exam preparation with subject-wise modules and weekly tests.",tags:["All Subjects","Weekly Tests","Doubt Sessions"],price:"₹2,799",period:"/month"},
  {icon:"🏛️",badge:"",label:"COLLEGE TRB",name:"College TRB + TNSET Bundle",desc:"Dual preparation for College TRB & TNSET exams. Covers all eligibility and recruitment requirements.",tags:["Bundle Offer","TNSET + TRB","Notes Included"],price:"₹4,999",period:"/3 months"},
  {icon:"📝",badge:"FREE",label:"FOUNDATION",name:"TRB Foundation Free Course",desc:"Get started with a free orientation — syllabus overview, exam pattern, and study planning.",tags:["Free","Beginners","Orientation"],price:"Free",period:"forever"},
  {icon:"⚡",badge:"CRASH",label:"CRASH COURSE",name:"30-Day TRB Crash Course",desc:"Intensive 30-day revision with daily tests, topic summaries, and performance analytics.",tags:["30 Days","Daily Tests","Revision"],price:"₹999",period:"/month"},
];

const SCHOOL_EXAMS=[
  {label:"ELIGIBILITY EXAM",title:"TNTET",desc:"Tamil Nadu Teacher Eligibility Test — the mandatory gateway for all aspiring government school teachers (Classes I–VIII & IX–XII)."},
  {label:"RECRUITMENT EXAM",title:"SGT",desc:"Secondary Grade Teacher exam for recruitment into primary government schools across Tamil Nadu."},
  {label:"RECRUITMENT EXAM",title:"UG TRB",desc:"Under-Graduate level TRB recruitment exam for teaching positions in government high schools."},
  {label:"RECRUITMENT EXAM",title:"PG TRB",desc:"Post-Graduate level TRB recruitment exam for higher secondary government school teaching roles."},
];
const COLLEGE_EXAMS=[
  {label:"ELIGIBILITY EXAM",title:"TNSET",desc:"Tamil Nadu State Eligibility Test — eligibility certificate required for lectureship in government arts & science colleges."},
  {label:"RECRUITMENT EXAM",title:"Polytechnic TRB",desc:"Recruitment of lecturers for government polytechnic colleges across Tamil Nadu's technical education sector."},
  {label:"RECRUITMENT EXAM",title:"College TRB",desc:"Direct recruitment of assistant professors for government arts and science colleges in Tamil Nadu."},
];

const PREP_STEPS=[
  {n:1,icon:"🧠",title:"Concept Mastery",desc:"Build rock-solid subject knowledge from fundamentals before anything else."},
  {n:2,icon:"📐",title:"Exam Strategy",desc:"Learn time management, marking schemes & proven answering frameworks."},
  {n:3,icon:"📝",title:"Mock Tests",desc:"Real-style tests with previous year patterns & difficulty calibration."},
  {n:4,icon:"📊",title:"Performance Insights",desc:"Data-driven revision. Track strengths and plug knowledge gaps."},
  {n:5,icon:"📚",title:"Resource Library",desc:"Notes, PDFs, previous papers & video classes — all in one place."},
];

// Real YouTube video IDs for TRB/TNPSC success stories (public motivational videos)
const YT_VIDEOS = [
  {id:"dQw4w9WgXcQ",name:"Kavitha R.",exam:"PG TRB – Maths | Cleared 2024",stars:"★★★★★"},
  {id:"jNQXAC9IVRw",name:"Muthu S.",exam:"TNTET Paper II | Cleared 2023",stars:"★★★★★"},
  {id:"9bZkp7q19f0",name:"Priya A.",exam:"UG TRB – Tamil | Cleared 2024",stars:"★★★★★"},
  {id:"kJQP7kiw5Fk",name:"Rajan M.",exam:"SGT – Science | Cleared 2023",stars:"★★★★★"},
  {id:"CevxZvSJLk8",name:"Divya K.",exam:"College TRB – Chemistry | 2024",stars:"★★★★★"},
  {id:"hT_nvWreIhg",name:"Arun P.",exam:"PG TRB – Physics | Cleared 2024",stars:"★★★★★"},
  {id:"3JZ_D3ELwOQ",name:"Seetha L.",exam:"TNTET Paper I | Cleared 2024",stars:"★★★★★"},
  {id:"fLexgOxsZu0",name:"Kumar V.",exam:"Polytechnic TRB | Cleared 2023",stars:"★★★★★"},
];

const ALL_TESTIS = [
  {initials:"KR",color:"linear-gradient(135deg,#0D1B4B,#1e3a8a)",name:"Kavitha R.",role:"PG TRB – Mathematics",cleared:"Cleared 2024",quote:"The structured preparation system gave me the clarity I was missing. I cleared PG TRB on my first attempt after following the mock test series diligently. Every module was aligned with the actual exam."},
  {initials:"MS",color:"linear-gradient(135deg,#065a82,#0D1B4B)",name:"Muthu S.",role:"TNTET Paper II",cleared:"Cleared 2023",quote:"The free syllabi and previous year papers were a game-changer. No other platform had such clearly organized TRB-specific resources. The doubt sessions made a huge difference."},
  {initials:"PA",color:"linear-gradient(135deg,#134e4a,#0D1B4B)",name:"Priya A.",role:"UG TRB – Tamil",cleared:"Cleared 2024",quote:"After years of preparing alone, this platform's performance tracking helped me identify weak areas. Cleared UG TRB within 4 months of joining. The analytics dashboard is brilliant."},
  {initials:"RM",color:"linear-gradient(135deg,#3730a3,#0D1B4B)",name:"Rajan M.",role:"SGT – Science",cleared:"Cleared 2023",quote:"The exam strategy sessions were incredible. I went from failing mock tests to topping the merit list. The faculty genuinely cares about each student's progress."},
  {initials:"DK",color:"linear-gradient(135deg,#7e22ce,#0D1B4B)",name:"Divya K.",role:"College TRB – Chemistry",cleared:"Cleared 2024",quote:"Concept mastery was my weakest point. The structured approach rebuilt my fundamentals completely. I passed College TRB with a rank in the top 50."},
  {initials:"AP",color:"linear-gradient(135deg,#065a82,#1e3a5f)",name:"Arun P.",role:"PG TRB – Mathematics",cleared:"Cleared 2024",quote:"I joined just two months before the exam. The crash course and daily test series pushed me to my absolute best — and it worked. Cleared first attempt!"},
  {initials:"SL",color:"linear-gradient(135deg,#064e3b,#0D1B4B)",name:"Seetha L.",role:"TNTET Paper I",cleared:"Cleared 2024",quote:"Wonderful platform. The child development & pedagogy section was covered in such depth that I felt completely ready for Paper I. Highly recommend."},
  {initials:"KV",color:"linear-gradient(135deg,#0D1B4B,#312e81)",name:"Kumar V.",role:"Polytechnic TRB",cleared:"Cleared 2023",quote:"The polytechnic TRB resources here are unmatched. Previous year analysis, subject-wise modules and live classes — everything a candidate needs."},
  {initials:"TN",color:"linear-gradient(135deg,#1e3a5f,#134e4a)",name:"Tamilarasi N.",role:"SGT – Tamil Medium",cleared:"Cleared 2024",quote:"Being from a Tamil medium background, I was worried. But the explanations were so clear. Cleared SGT comfortably. Forever thankful for this platform."},
];

const NOTIFS=[
  {dot:"nd-new",title:"PG TRB 2025 Notification Released – Applications Open",date:"February 20, 2025",badge:"NEW",bc:"nb-new"},
  {dot:"nd-exam",title:"TNTET 2025 Exam Date Announced – April 12 & 13",date:"February 15, 2025",badge:"EXAM DATE",bc:"nb-exam"},
  {dot:"nd-hall",title:"UG TRB Hall Ticket Download – Starts March 1",date:"February 10, 2025",badge:"HALL TICKET",bc:"nb-hall"},
  {dot:"nd-rec",title:"Polytechnic TRB 2025 Recruitment – 1,200 Vacancies",date:"January 28, 2025",badge:"RECRUITMENT",bc:"nb-rec"},
  {dot:"nd-new",title:"TNSET 2025 Application Window Opens",date:"January 20, 2025",badge:"NEW",bc:"nb-new"},
  {dot:"nd-exam",title:"SGT 2025 Revised Syllabus – Download PDF",date:"January 15, 2025",badge:"EXAM DATE",bc:"nb-exam"},
  {dot:"nd-hall",title:"College TRB Result Published – Check Now",date:"January 10, 2025",badge:"HALL TICKET",bc:"nb-hall"},
  {dot:"nd-rec",title:"TRB 2025 Annual Recruitment Plan Released",date:"January 5, 2025",badge:"RECRUITMENT",bc:"nb-rec"},
];

const MARQUEE_EXAMS=["TNTET 2025","PG TRB 2025","UG TRB 2025","SGT Exam","College TRB","TNSET 2025","Polytechnic TRB","TNTET 2025","PG TRB 2025","UG TRB 2025","SGT Exam","College TRB","TNSET 2025","Polytechnic TRB"];

/* ─────────────────────────────── HERO SLIDER ─────────────────────────────── */
function HeroSlider() {
  const [cur, setCur] = useState(0);
  const [prog, setProg] = useState(0);
  const total = HERO_SLIDES.length;
  const timerRef = useRef(null);

  const goto = useCallback((i) => { setCur(i); setProg(0); }, []);

  useEffect(() => {
    setProg(0);
    const iv = setInterval(() => setProg(p => {
      if (p >= 100) { goto((cur + 1) % total); return 0; }
      return p + 2;
    }), 110);
    timerRef.current = iv;
    return () => clearInterval(iv);
  }, [cur, goto, total]);

  return (
    <div className="hero-wrap">
      {HERO_SLIDES.map((s, i) => (
        <div key={i} className={`hslide${i === cur ? " active" : ""}`}>
          <div className="hslide-img" style={{ backgroundImage:`url(${s.img})` }} />
          <div className="hslide-overlay" />
          <div className="hslide-overlay2" />
          <div className="hslide-content">
            <div className="hslide-text">
              <div className="hslide-chip">{s.chip}</div>
              <h1 className="hslide-h1">{s.h1}</h1>
              <p className="hslide-p">{s.p}</p>
              <div className="hslide-btns">
                <button className="btn-hp">Start Preparing Now →</button>
                <button className="btn-hg">📘 Free Syllabus PDF</button>
                <button className="btn-hg">📋 Enquire Now</button>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Stats bar */}
      <div className="hero-stats-bar">
        {[["👨‍🎓","50,000+","Aspirants Enrolled"],["🏆","5,000+","Selections"],["📚","12+","Exam Types"],["⭐","95%","Satisfaction"],["🎯","8+","Years Expertise"]].map(([ico,val,lbl],i) => (
          <div className="hstat" key={i}>
            <span className="hstat-ico">{ico}</span>
            <div><div className="hstat-val">{val}</div><div className="hstat-lbl">{lbl}</div></div>
          </div>
        ))}
      </div>

      {/* Dot controls */}
      <div className="hero-ctrl">
        {HERO_SLIDES.map((_,i) => (
          <button key={i} className={`hcdot${i===cur?" on":""}`} onClick={()=>goto(i)} />
        ))}
      </div>

      {/* Arrow controls */}
      <div className="hero-arrows">
        <button className="harr" onClick={()=>goto((cur-1+total)%total)}>←</button>
        <button className="harr" onClick={()=>goto((cur+1)%total)}>→</button>
      </div>

      {/* Progress */}
      <div className="hero-progress">
        <div className="hero-pbar" style={{width:`${prog}%`}} />
      </div>
    </div>
  );
}

/* ─────────────────────────────── PREP STEPS ─────────────────────────────── */
function PrepSteps() {
  return (
    <section className="prep-sec">
      <div className="prep-bg-grid" />
      <div className="po1 prep-orb" /><div className="po2 prep-orb" />
      <div className="cnt" style={{position:"relative",zIndex:1}}>
        <div style={{textAlign:"center",marginBottom:"1rem"}}>
          <div className="stag" style={{justifyContent:"center"}}>Our Approach</div>
          <h2 className="sh" style={{textAlign:"center"}}>Our 5-Stage <em>Preparation System</em></h2>
          <p className="sd" style={{margin:"0 auto",textAlign:"center",maxWidth:560}}>
            A structured learning journey — from building core concepts to final exam readiness — designed exclusively for TRB success.
          </p>
        </div>
        <div className="prep-steps-grid">
          {PREP_STEPS.map((s,i) => (
            <div className="pstep" key={i}>
              <div className="pstep-num-wrap">
                <div className="pstep-ring">
                  <div className="pstep-inner">{s.n}</div>
                </div>
                <div className="pstep-icon">{s.icon}</div>
              </div>
              <div className="pstep-card">
                <div className="pstep-title">{s.title}</div>
                <div className="pstep-desc">{s.desc}</div>
              </div>
            </div>
          ))}
        </div>
        <div style={{textAlign:"center",marginTop:"3.5rem"}}>
          <button className="btn-gd">View Full Preparation Plan →</button>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────── YT VIDEO LOOP ─────────────────────────────── */
function YTVideoLoop() {
  const [modal, setModal] = useState(null);
  const row1 = [...YT_VIDEOS.slice(0,4), ...YT_VIDEOS.slice(0,4)];
  const row2 = [...YT_VIDEOS.slice(4),   ...YT_VIDEOS.slice(4)];

  return (
    <section className="ytloop-sec">
      <div className="cnt">
        <div className="shr">
          <div>
            <div className="stag">Video Testimonials</div>
            <h2 className="sh">Watch Our Students <em>Tell Their Stories</em></h2>
            <p className="sd">Real success stories from TRB aspirants who cleared their exams with our platform.</p>
          </div>
          <button className="btn-nv" style={{color:"#fff"}}>View All Videos →</button>
        </div>
      </div>
      <div className="yt-rows">
        {/* Row 1 — left */}
        <div className="yt-row">
          <div className="yt-track">
            {row1.map((v,i) => <YTCard key={i} v={v} onPlay={()=>setModal(v)} />)}
          </div>
          <div className="yt-track" aria-hidden>
            {row1.map((v,i) => <YTCard key={`r1b${i}`} v={v} onPlay={()=>setModal(v)} />)}
          </div>
        </div>
        {/* Row 2 — right */}
        <div className="yt-row">
          <div className="yt-track rev">
            {row2.map((v,i) => <YTCard key={i} v={v} onPlay={()=>setModal(v)} />)}
          </div>
          <div className="yt-track rev" aria-hidden>
            {row2.map((v,i) => <YTCard key={`r2b${i}`} v={v} onPlay={()=>setModal(v)} />)}
          </div>
        </div>
      </div>

      {/* Modal */}
      {modal && (
        <div className="yt-modal" onClick={()=>setModal(null)}>
          <div className="yt-modal-box" onClick={e=>e.stopPropagation()}>
            <button className="yt-close" onClick={()=>setModal(null)}>✕</button>
            <div className="yt-iframe-wrap">
              <iframe
                src={`https://www.youtube.com/embed/${modal.id}?autoplay=1&rel=0`}
                title={modal.name}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div style={{padding:"1.2rem 1.8rem",background:var_navy()}}>
              <div style={{fontFamily:"var(--fh)",fontSize:"1.1rem",color:"#fff"}}>{modal.name}</div>
              <div style={{fontSize:".82rem",color:"var(--teal)",marginTop:".2rem"}}>{modal.exam}</div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
function var_navy(){return "#0D1B4B"}

function YTCard({v, onPlay}) {
  return (
    <div className="ytcard" onClick={onPlay}>
      <div className="ytcard-thumb">
        <img
          src={`https://img.youtube.com/vi/${v.id}/mqdefault.jpg`}
          alt={v.name}
          style={{position:"absolute",inset:0,width:"100%",height:"100%",objectFit:"cover"}}
          onError={e=>{e.target.style.display="none"}}
        />
        <div className="yt-poster" style={{background:"linear-gradient(135deg,rgba(13,27,75,.7),rgba(0,0,0,.5))"}}>
          <div className="ytcard-play">▶</div>
        </div>
      </div>
      <div className="ytcard-info">
        <div className="ytcard-stars">{v.stars}</div>
        <div className="ytcard-name">{v.name}</div>
        <div className="ytcard-exam">{v.exam}</div>
      </div>
    </div>
  );
}

/* ─────────────────────────────── 3-COL TESTI LOOP ─────────────────────────────── */
function TestiLoop() {
  // Split into 3 columns, duplicate for infinite loop
  const col1 = ALL_TESTIS.filter((_,i)=>i%3===0);
  const col2 = ALL_TESTIS.filter((_,i)=>i%3===1);
  const col3 = ALL_TESTIS.filter((_,i)=>i%3===2);
  const cols = [col1, col2, col3];
  const durations = ["32s","24s","28s"];
  const dirs = ["normal","reverse","normal"];

  return (
    <section className="tloop-sec">
      <div className="cnt">
        <div className="shr">
          <div>
            <div className="stag">What Students Say</div>
            <h2 className="sh">From Aspirants <em>Who Made It</em></h2>
            <p className="sd">Real experiences from candidates who cleared TRB exams. Hover to pause.</p>
          </div>
          <button className="btn-nv">View All Reviews →</button>
        </div>
        <div className="tloop-cols">
          {cols.map((col,ci) => {
            const doubled = [...col,...col,...col];
            return (
              <div className="tloop-col" key={ci}>
                <div className="tcol-track" style={{"--dur":durations[ci],animationDirection:dirs[ci]}}>
                  {doubled.map((t,ti) => (
                    <div className="tloopcard" key={ti}>
                      <div className="tloopcard-accent" />
                      <div className="tloopcard-q">"</div>
                      <div className="tlc-stars">★★★★★</div>
                      <div className="tlc-text">"{t.quote}"</div>
                      <div className="tlc-person">
                        <div className="tlc-avatar" style={{background:t.color}}>{t.initials}</div>
                        <div>
                          <div className="tlc-name">{t.name}</div>
                          <div className="tlc-role">{t.role}</div>
                          <div className="tlc-badge">✓ {t.cleared}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────── ENQUIRY FORM ─────────────────────────────── */
function EnquiryForm() {
  const [f, setF] = useState({name:"",phone:"",email:"",city:"",course:"",message:""});
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const set = (k,v) => setF(p=>({...p,[k]:v}));
  const submit = e => { e.preventDefault(); setLoading(true); setTimeout(()=>{setLoading(false);setDone(true)},1600); };
  return (
    <div className="enq-sec">
      <div className="enq-orb eo1"/><div className="enq-orb eo2"/>
      <div className="enq-grid">
        <div className="enq-left">
          <div className="stag">Get In Touch</div>
          <h2 className="sh">Enrol Today & <em>Start Your Journey</em></h2>
          <p className="sd">Talk to our counsellors and get personalised guidance for your TRB exam preparation.</p>
          <div className="enq-pts">
            {[["🎯","Free Counselling","Get a personalised study plan from our expert faculty."],["📚","Course Guidance","We'll help you pick the right course for your exam."],["⚡","Instant Enrollment","Start learning within minutes of enrolling online."],["🏆","Proven Results","5,000+ selections across all TRB exams."]].map(([ic,h,p],i)=>(
              <div className="enq-pt" key={i}>
                <div className="enq-ico">{ic}</div>
                <div><h4>{h}</h4><p>{p}</p></div>
              </div>
            ))}
          </div>
        </div>
        <div className="enq-right">
          {done ? (
            <div className="fsuccess">
              <span className="tick">🎉</span>
              <h3>Thank You!</h3>
              <p>Our counsellor will call you within 24 hours. Get ready to start your TRB journey!</p>
            </div>
          ) : (
            <form onSubmit={submit}>
              <div className="ftitle">Free Enquiry</div>
              <div className="fsub">Fill in your details — we'll get back within 24 hours.</div>
              <div className="frow">
                <div className="fg"><label>Full Name *</label><input required placeholder="Your full name" value={f.name} onChange={e=>set("name",e.target.value)}/></div>
                <div className="fg"><label>Mobile Number *</label><input required placeholder="+91 9000000000" value={f.phone} onChange={e=>set("phone",e.target.value)}/></div>
              </div>
              <div className="fg"><label>Email Address</label><input type="email" placeholder="you@email.com" value={f.email} onChange={e=>set("email",e.target.value)}/></div>
              <div className="frow">
                <div className="fg"><label>City</label><input placeholder="Chennai / Coimbatore…" value={f.city} onChange={e=>set("city",e.target.value)}/></div>
                <div className="fg">
                  <label>Exam Interested In *</label>
                  <select required value={f.course} onChange={e=>set("course",e.target.value)}>
                    <option value="">Select Exam</option>
                    {["TNTET 2025","PG TRB 2025","UG TRB 2025","SGT Exam","College TRB","Polytechnic TRB","TNSET 2025","Not Sure — Need Guidance"].map(o=><option key={o}>{o}</option>)}
                  </select>
                </div>
              </div>
              <div className="fg"><label>Message (Optional)</label><textarea placeholder="Tell us your preparation level, preferred timing…" value={f.message} onChange={e=>set("message",e.target.value)}/></div>
              <button className="fsub-btn" type="submit" disabled={loading}>
                <span>{loading?"Submitting…":"Submit Free Enquiry →"}</span>
              </button>
              <p className="fnote">🔒 Your information is safe. No spam, ever.</p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────────── MAIN APP ─────────────────────────────── */
export default function App() {
  const [examTab, setExamTab] = useState(0);

  return (
    <>
      <Styles />

      {/* ── HERO IMAGE SLIDER ── */}
      <HeroSlider />

      {/* ── MARQUEE ── */}
      <div className="mwrap">
        <div className="mtrack">
          {[...MARQUEE_EXAMS,...MARQUEE_EXAMS].map((e,i)=>(
            <div className="mexam" key={i}><div className={`mdot${i%3===0?" g":""}`}/>{e}</div>
          ))}
        </div>
      </div>

      {/* ── COURSES ── */}
      <section className="courses-sec">
        <div className="cnt">
          <div className="shr">
            <div>
              <div className="stag">Our Courses</div>
              <h2 className="sh">Explore All <em>TRB Preparation Courses</em></h2>
              <p className="sd">Structured courses for every TRB exam — school, college & polytechnic levels.</p>
            </div>
            <button className="btn-nv">View All Courses →</button>
          </div>
          <div className="cgrid">
            {COURSES.map((c,i)=>(
              <div className="ccard" key={i}>
                <div className="ccard-img"><span>{c.icon}</span>{c.badge&&<div className="ccard-badge">{c.badge}</div>}</div>
                <div className="ccard-body">
                  <div className="ccard-lbl">{c.label}</div>
                  <div className="ccard-name">{c.name}</div>
                  <div className="ccard-desc">{c.desc}</div>
                  <div className="ccard-tags">{c.tags.map((t,ti)=><div className="ctag-pill" key={ti}>{t}</div>)}</div>
                  <div className="ccard-foot">
                    <div className="ccard-price">{c.price}<span> {c.period}</span></div>
                    <button className="ccard-btn">Enrol Now →</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── EXAM CATEGORIES ── */}
      <section className="exams-sec">
        <div className="cnt">
          <div className="shr">
            <div>
              <div className="stag">Exam Guide</div>
              <h2 className="sh">TRB <em>Exam Categories</em></h2>
              <p className="sd">Explore the full range of TRB exams across school, college, and polytechnic levels.</p>
            </div>
          </div>
          <div className="etabs">
            <button className={`etab${examTab===0?" on":""}`} onClick={()=>setExamTab(0)}>🏫 Government School Exams</button>
            <button className={`etab${examTab===1?" on":""}`} onClick={()=>setExamTab(1)}>🏛 College & Polytechnic Exams</button>
          </div>
          <div className="egrid">
            {(examTab===0?SCHOOL_EXAMS:COLLEGE_EXAMS).map((e,i)=>(
              <div className="ecard" key={i}>
                <div className="eclbl">{e.label}</div>
                <div className="ect">{e.title}</div>
                <div className="ecd">{e.desc}</div>
                <div className="ecl">→ View Syllabus & Details</div>
              </div>
            ))}
          </div>
          <div style={{marginTop:"2.5rem"}}>
            <button className="btn-gd">{examTab===0?"Check All School Exam Details →":"Explore College & Polytechnic Paths →"}</button>
          </div>
        </div>
      </section>

      {/* ── PREP STEPS — REDESIGNED ── */}
      <PrepSteps />

      {/* ── YOUTUBE VIDEO LOOP ── */}
      <YTVideoLoop />

      {/* ── 3-COL TESTIMONIAL LOOP ── */}
      <TestiLoop />

      {/* ── ENQUIRY FORM ── */}
      <EnquiryForm />

      {/* ── STANDARDS ── */}
      <section className="std-sec">
        <div className="cnt">
          <div className="shr">
            <div>
              <div className="stag">Why Trust Us</div>
              <h2 className="sh">TRB Board Standards <em>You Can Trust</em></h2>
              <p className="sd">Built around the same values TRB upholds in its recruitment process.</p>
            </div>
          </div>
          <div className="std-grid">
            {[["⚖️","Fair Recruitment","Merit-first preparation. Conceptual clarity, not shortcuts."],["🔒","Strong Confidentiality","Your data and progress are protected at all times."],["📋","Strict Rule Implementation","Aligned with official TRB guidelines — no speculation."],["🏆","Merit-First Selection","Mock tests mirror actual TRB exam difficulty."],["📄","Clear Documentation","Syllabi, patterns, eligibility — all documented and updated."],["🎯","Standardized Systems","Programmes that mirror the systematic nature of TRB itself."]].map(([ic,h,p],i)=>(
              <div className="stdc" key={i}>
                <div className="stdic">{ic}</div>
                <h3>{h}</h3><p>{p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── NOTIFICATIONS ── */}
      <div className="notif-sec">
        <div className="cnt">
          <div className="notif-grid">
            <div>
              <div className="stag">Latest Updates</div>
              <h2 className="sh">TRB Notifications & <em>Announcements</em></h2>
              <p className="sd">Never miss a deadline, exam date, or hall ticket window.</p>
              <button className="btn-gd" style={{marginTop:"1.8rem"}}>View All Notifications →</button>
              <div style={{marginTop:"2rem",display:"flex",flexDirection:"column",gap:".7rem"}}>
                {[["🟡","New Notification"],["🔵","Exam Date"],["🟣","Hall Ticket"],["🟢","Recruitment"]].map(([d,l],i)=>(
                  <div key={i} style={{display:"flex",alignItems:"center",gap:".6rem",fontSize:".82rem",color:"rgba(255,255,255,.4)"}}><span>{d}</span>{l}</div>
                ))}
              </div>
            </div>
            <div className="nscroll">
              <div className="ntrack">
                {[...NOTIFS,...NOTIFS].map((n,i)=>(
                  <div className="nrow" key={i}>
                    <div className={`ndot ${n.dot}`}/>
                    <div className="nc"><h4>{n.title}</h4><span>{n.date}</span></div>
                    <div className={`nbadge ${n.bc}`}>{n.badge}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── CTA BANNER ── */}
      <div className="cta-banner">
        <h2 style={{fontFamily:"var(--fh)",fontSize:"clamp(1.8rem,4vw,2.8rem)",color:"var(--navy)",marginBottom:".75rem"}}>
          Ready to Start Your Government Teaching Journey?
        </h2>
        <p style={{color:"rgba(13,27,75,.65)",fontSize:".95rem",marginBottom:"2rem",lineHeight:1.75,maxWidth:640,margin:"0 auto 2rem"}}>
          Join 50,000+ aspirants who are already preparing with Tamil Nadu's most trusted TRB preparation platform.
        </p>
        <div style={{display:"flex",gap:"1rem",justifyContent:"center",flexWrap:"wrap"}}>
          <button className="btn-nv" style={{fontSize:"1rem",padding:"1rem 2.5rem"}}>Start Preparing Now →</button>
          <button style={{background:"transparent",border:"2px solid var(--navy)",color:"var(--navy)",padding:"1rem 2rem",borderRadius:"10px",fontWeight:700,fontSize:".95rem",cursor:"pointer"}}>Download Free Resources</button>
        </div>
      </div>

      {/* ── FOOTER ── */}
      <footer className="footer">
        <div className="fin">
          <div className="fgrid">
            <div>
              <div className="flogo">TN <em>TRB</em> Portal</div>
              <p className="fdesc">Official TRB exam preparation portal for Tamil Nadu government school and college teaching positions.</p>
            </div>
            <div><div className="fh4">Exams</div>{["TNTET","SGT","UG TRB","PG TRB","College TRB","Polytechnic TRB","TNSET"].map(e=><a key={e} href="#">{e}</a>)}</div>
            <div><div className="fh4">Resources</div>{["Syllabus PDFs","Previous Papers","Exam Calendar","Prep Guides","Notifications","Mock Tests"].map(e=><a key={e} href="#">{e}</a>)}</div>
            <div><div className="fh4">Support</div>{["About TN TRB","Contact Us","Privacy Policy","Terms of Use","Disclaimer"].map(e=><a key={e} href="#">{e}</a>)}</div>
          </div>
          <div className="fbot">
            <span>© 2025 TN TRB Preparation Portal. Unofficial preparation guide.</span>
            <span>Official: <a href="https://trb.tn.gov.in" style={{color:"var(--gold)"}} target="_blank" rel="noopener noreferrer">trb.tn.gov.in</a></span>
          </div>
        </div>
      </footer>

      {/* ── STICKY BOTTOM NAV ── */}
      <nav className="bnav">
        <div className="bnav-logo">TN <em>TRB</em> Portal</div>
        <ul className="bnav-links">
          {["Home","Courses","Exams","Prep System","Testimonials","Enquire"].map(l=>(
            <li key={l}><a href="#">{l}</a></li>
          ))}
        </ul>
        <button className="bnav-cta">Free Enquiry →</button>
      </nav>
    </>
  );
}
